import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {VisualizarImagemOriginalComponent} from '../visualizar-imagem-original.component';


const visualizarImagemOriginalRotas: Routes = [
  {path: '', component: VisualizarImagemOriginalComponent}
];

@NgModule({
  imports: [
    RouterModule.forChild(visualizarImagemOriginalRotas)
  ],
  exports: [RouterModule]
})

export class VisualizarImagemOriginalRotasModule {
}
